import { MantineThemeOverride } from '@mantine/core';

import { UIConfig } from 'stores/global/RootStore/AppConfigStore';

export function createDynamicTheme(baseTheme: MantineThemeOverride, ui: UIConfig): MantineThemeOverride {
  if (ui.colors.length === 0) {
    return {
      ...baseTheme,
      primaryColor: ui.primaryColor,
    };
  }

  const dynamicColors: MantineThemeOverride['colors'] = {};

  ui.colors.forEach(({ type, value }) => {
    if (Array.isArray(value)) {
      dynamicColors[type] = value;
    }
  });

  return {
    ...baseTheme,
    primaryColor: ui.primaryColor,
    primaryShade: ui.primaryShade,
    colors: {
      ...dynamicColors,
    },
  };
}
